import { required, email } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      email: '',
      user: {
        isSubscribed: false
      }
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  methods: {
    async onLoggedIn () {
      const currentUser = this.$store.state?.user?.current
      if (!currentUser?.email) return

      this.email = currentUser.email
      this.user.isSubscribed = await this.$store.dispatch('newsletter/status', this.email)
    }
  },
  beforeMount () {
    if (this.$store.state.user.current) this.onLoggedIn()
    this.$bus.$on('user-after-loggedin', this.onLoggedIn)
  },
  beforeDestroy () {
    this.$bus.$off('user-after-loggedin', this.onLoggedIn)
  },
  computed: {
    isSubscribed (): boolean {
      return this.$store.getters['newsletter/isSubscribed']
    }
  }
}
